/**
 * Pestanas de origen del Radar — Nacional / Internacional.
 *
 * Accesibilidad: role="tablist" + role="tab" + aria-selected, siguiendo
 * el patron ARIA Tabs. El panel de contenido lo controla Radar.tsx.
 */
export type RadarTab = "national" | "international";

const TABS: { value: RadarTab; label: string }[] = [
  { value: "national", label: "Nacional" },
  { value: "international", label: "Internacional" },
];

export function RadarTabs({
  value,
  onChange,
}: {
  value: RadarTab;
  onChange: (next: RadarTab) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="Origen de las convocatorias"
      className="mb-4 flex gap-1 border-b border-slate-200"
    >
      {TABS.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.value)}
            className={
              "-mb-px border-b-2 px-4 py-2 text-sm font-semibold transition " +
              (active
                ? "border-brand-700 text-brand-700"
                : "border-transparent text-slate-500 hover:text-slate-700")
            }
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
